import { Component, EventEmitter, Input, Optional, Output } from '@angular/core';
import { SmartTableService } from '../smart-table.service';
import { SmartTableConsumer } from '../smart-table-consumer';

@Component({
	selector: 'ws-smart-clear-filters',
	templateUrl: './smart-clear-filters.component.html',
	styleUrls: ['./smart-clear-filters.component.scss'],
})
export class SmartClearFiltersComponent extends SmartTableConsumer {
	@Input() preserveSorts = false;
	@Output() cleared = new EventEmitter<void>();

	constructor(@Optional() smartTableService: SmartTableService) {
		super(smartTableService);
	}

	get hasActiveCriteria(): boolean {
		return this.smartTableService.hasActiveCriteria;
	}

	clear(): void {
		this.smartTableService.clearAll(this.preserveSorts);
		this.cleared.emit();
	}
}
